//Import all frontend scripts here

// header
import { headerInit } from './components/header';

headerInit();
